import { bindable, bindingMode } from 'aurelia-framework';

export class BankRoutingNumber {
	@bindable({ defaultBindingMode: bindingMode.twoWay }) routingNumber: any;

	constructor() {
	}
}
